import { Card as BaseCard, CardProps } from 'baseui/card';

const defaultHasThumbnail = (props: { thumbnail?: string }) => !!props.thumbnail;

export const Card = (props: Partial<CardProps>) => {
    return (
        <BaseCard
            hasThumbnail={defaultHasThumbnail}
            {...props}
            overrides={{
                Root: {
                    style: {
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                        borderBottomLeftRadius: '8px',
                        borderBottomRightRadius: '8px',
                        ...props.overrides?.Root?.style,
                    },
                },
                ...props.overrides,
            }}
        />
    );
};
